/**
 * 后台屏幕宽度（PRD §3.3.1、§8.6「管理后台」；platform REQ-8.6-005）：后台只做桌面端，屏幕宽度 ≥1280 像素；
 * 窄于 1280 像素时整个后台（含登录页）只显示"请在宽度 1280 像素以上的屏幕上使用后台"。
 * 判断同时看窗口宽度与屏幕宽度：桌面浏览器窗口缩窄、以及手机按 1280 视口缩放显示的情况都会提示。
 */
import { useI18n } from '@nexora/i18n/react';
import { useEffect, useState, type ReactNode } from 'react';

export const ADMIN_MIN_WIDTH = 1280;

export function isWideEnough(win: Pick<Window, 'innerWidth'> & { screen?: { width: number } } = window): boolean {
  if (win.innerWidth < ADMIN_MIN_WIDTH) return false;
  const screenWidth = win.screen?.width ?? 0;
  // 部分环境（无头浏览器、jsdom）不报告屏幕宽度，此时只看窗口宽度
  return screenWidth <= 0 || screenWidth >= ADMIN_MIN_WIDTH;
}

export function WidthGate({ children }: { children: ReactNode }) {
  const { t } = useI18n();
  const [wide, setWide] = useState(() => isWideEnough());
  useEffect(() => {
    const update = () => setWide(isWideEnough());
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  if (wide) return <>{children}</>;
  return (
    <div className="flex min-h-dvh items-center justify-center bg-bg p-6 text-fg" data-width-gate="">
      <div className="max-w-md text-center">
        {/* 含普通文字（"管理后台"），用正文色而不是渐变（对比度 ≥4.5:1，PRD §8.7） */}
        <p className="text-xl font-bold text-fg">{t('admin.appName')}</p>
        <p role="alert" className="mt-4 text-lg font-semibold">
          {t('admin.narrowScreen')}
        </p>
      </div>
    </div>
  );
}
